// extracted by mini-css-extract-plugin
module.exports = {"initiativeCardSummary":"InitiativeCardSummary_initiativeCardSummary__2bxrN"};